import { Pipe, PipeTransform } from '@angular/core';
import { TextTransformType } from '@shared/models';

@Pipe({
	name: 'textTransform'
})
export class TextTransformPipe implements PipeTransform {

	transform(value: string | number | null | undefined, transformType?: TextTransformType, fallback?: string, maxLength?: number): string {
		// Convert number to string if needed
		const stringValue = value !== null && value !== undefined ? value.toString() : '';

		if (!stringValue || stringValue.trim() === '') {
			return fallback || '--';
		}

		// Set defaults
		const type = transformType || TextTransformType.Capitilized;
		const length = maxLength || 50;

		let transformedValue = stringValue;

		switch (type) {
			case TextTransformType.Uppercase:
				transformedValue = stringValue.toUpperCase();
				break;
			case TextTransformType.Lowercase:
				transformedValue = stringValue.toLowerCase();
				break;
			case TextTransformType.Titlecase:
				transformedValue = this.toTitleCase(stringValue);
				break;
			case TextTransformType.Capitilized:
				transformedValue = this.capitalizeFirstLetter(stringValue);
				break;
			case TextTransformType.Trancuate:
				transformedValue = this.truncateText(stringValue, length);
				break;
			default:
				transformedValue = stringValue;
		}

		return transformedValue;
	}

	private toTitleCase(str: string): string {
		return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
	}

	private capitalizeFirstLetter(str: string): string {
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	}

	private truncateText(str: string, maxLength: number): string {
		if (str.length <= maxLength) {
			return str;
		}
		return str.substring(0, maxLength) + '...';
	}
}
